export const UPDATE_DIRECTION="getDirection";

export const LOGOUT = 'logout';//注销登陆

export const LOGIN = 'login';

export const OPENID='openId';
//保存配件
export const SAVE_PARTS = 'saveParts';

//设置上个路由
export const ROUTER_HISTORY ='routerHistroy';

//所有的配件参数
export const SAVE_SERVICESPARAMS = "saveServicesParams";
//所有的配件数据
export const SAVE_GROUPSERVICES ="saveGroupServices";
//已经选择的配件
export const SAVE_SERVICESID ='saveServicesId';
//选择被更换的配件
export const SAVE_CHOSEPARTS ="saveChoseParts";
//选择被更换的配件的父类型ID
export const SAVE_CHOSEPID ="saveChosePId";
//需要更换的配件
export const SAVE_REPLACEPARTS ="saveReplaceParts";
//车的型号
export const  CAR_BRAND ='saveCarBrand';//车的品牌
export const  CAR_MODEL ='saveCarModel';//车的系列
export const  CAR_DISPLACEMENT ='saveCarDisplacement';//车的排量
export const  CAR_YEAR ='saveCarYear';//车的生产年份
export const  CAR_INFO ='saveCarInfo';//车的型号
//保存订单信息
export const SAVE_ORDERINFO = 'saveOrderInfo';
//城市
export const SAVE_CITY='saveCity';
//地址
export const SAVE_ADDRESS='saveAddress';



// WEBPACK FOOTER //
// ./src/vuex/actions.js